// Headers
export const devicesMessageTypeEvent = "EdgeData";
export const alarmsMessageTypeEvent = "AlarmMessage";
export const stateChangedUpdateEvent = "EdgeEvent";

// Alarms
export const getAllDeviceAlarmsHistoryUrl = "/api/alarmHistory";
export const getAlarmLimits = "/api/getAlarmLimits"; // for one parameter
export const getAllAlarmLimits = "/api/getAllAlarms"; // for one device
export const updateAlarmLimits = "/api/updateAlarmLimits"; // for one parameter
export const restoreDefaultAlarmLimits = "/api/restoreDefaultAlarmLimits"; // for one parameter
export const clearAlarm = "/api/clearAlarm"
export const clearAllAlarms = "/api/clearAllAlarms"
export const toggleAllAlarmsHandlingForDevice = "/api/toggleAllAlarmsHandlingForDevice";
export const toggleSingleAlarm = "/api/toggleSingleAlarm";

export const refreshSignalRUrl = "/api/refreshSignalR";

// Commands
export const sendCommandUrl = "/api/sendCommand";

// CONFIGS
export const configurationUrl = "/api/moduleconfig";
// ---- Sensor Management
export const readSensorConfig = "api/readsensorconfig";
export const createSensorConfig = "api/createsensorconfig";
export const updateSensorConfig = "api/updatesensorconfig";
export const deleteSensorConfig = "api/deletesensorconfig";


// Settings
export const getSettingUrl = "/api/getsettings";
export const setSettingUrl = "/api/updatesettings";

// Reports
export const getReportUrl = "/api/getReport";
export const getReportRangeUrl = "/api/getReportRange";
export const resendReportsUrl = "/api/resendReports";

// Customers
export const postCustomersUrl = "/api/updateSites";

// Trend
export const getDeviceHistoryUrl = "/api/history";
export const newTrendUrl = "/api/trendrange";
export const trendPreLoadShortUrl = "/api/pre_load_short";
export const trendPreLoadLongUrl = "/api/pre_load_long";

// New InfluxDB Endpoints
export const influxLoadRangeUrl = "/api/influx_load_range";
export const influxLoadStatusUrl = "/api/influx_load_status";
export const influxQueryRangeUrl = "/api/influx_query_range";
export const influxHotpathBackfillUrl = "/api/influx_load_hotpath_backfill";

//Graphics
export const getGraphicsUrl = "/api/configs";

// Device parameters
export const getDeviceParamaters = "/api/getParameters";
export const updateDeviceParamater = "/api/updateParameter";

// Lora Name change
export const getSensorName = "/api/getSensorName";
export const updateSensorName = "/api/updateSensorName";

// IOT MODULES
export const getIotModules = "/api/getIotModules";
// export const sendIotModuleCommand = "/api/sendIotModuleCommand"; // not in use, use existing sendCommandUrl

// Pincode
export const pincodeStatusUrl = "/api/pincode/status";
export const pincodeValidateUrl = "/api/pincode/validate";
export const pincodeChangeUrl = "/api/pincode/change";
export const pincodeRemoveUrl = "/api/pincode/remove";

// Custom Alarms
export const createNewAlarmUrl = "/api/createNewCustomAlarm";
export const deleteCustomAlarmUrl = "/api/deleteCustomAlarm";